<template>
  <SearchYear :title="'Contas da Festa'" :minYear="1979" :directory="'contas_festa'" />
</template>

<script>
import SearchYear from '@/components/SearchYear.vue';

export default {
  components: {
    SearchYear
  }
};
</script>

<style>
</style>
